module.exports = __webpack_public_path__ + "media/images/course/aula_01__-48c3f645f64a344ea22f19cf79c4e5f8.png";